<template>
  <div class="imgPage">
    <div class="imgPageBox">
      <!-- <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/87990928__1772532979998.png" /> -->

      <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/26658546__1772533002425.png" />

      <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/83077503__1772533028341.png" />

      <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/59948900__1772533049247.png" />

      <!-- <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/28704668__1772533063904.png" /> -->

      <!-- <img
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/10545277__1772533080336.png" /> -->

    </div>
  </div>
</template>
<script>

export default {
  name: 'imgPage',
  computed: {},
  data() {
    return {
    }
  },
  mounted() { },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.imgPage{
  background $color-white
  .imgPageBox {
    background $color-white 
    padding 25px 0 
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
  }
}
</style>
